import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bytedance/Desktop/gatsby/src/components/BlogLayout/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`你有什么爱好吗？`}</p>
    <p>{`当被问到这个问题，我第一反应是文字。`}</p>
    <p>{`或者说，写文。`}</p>
    <p>{`爱好？文字？是不是有些奇怪？`}</p>
    <p>{`坦诚点讲，性别男，爱好女。`}</p>
    <p>{`正经点讲，落笔成文，我手写我心。`}</p>
    <p>{`私以为文字的魅力在于表达的两面性，最动人也最伤人，最温柔也最冰冷。`}</p>
    <p>{`而我，恰好喜欢游走在这种极端的边缘，疯狂试探。`}</p>
    <p>{`皓月当空，月华如水。`}</p>
    <p>{`一句月色真美，一句风也温柔，岂不美哉？`}</p>
    <p>{`一句月色真美，一句适合刺猹，也是美哉？`}</p>
    <p>{`前者两人如愿，后者一人称心。`}</p>
    <p>{`看过了柔情似水，咱们再来看看少年凌云壮志。`}</p>
    <p>{`“三十年河东，三十年河西，莫欺少年穷!”是何等的热血？`}</p>
    <p>{`“林动师兄，请壮我道宗!” 又是何等的悲壮？`}</p>
    <p>{`“若本世子身死，徐骁必叫你广陵满城尽悬北凉刀，信否？”又是何等的霸气？`}</p>
    <p>{`没有人总是少年，但总有人是少年。`}</p>
    <p>{`与我而言，文字，便永远是少年。`}</p>
    <p>{`我喜欢写文，是喜欢与自己的另一个灵魂交流。`}</p>
    <p>{`在帝都这个快节奏的城市，只有真正静下来写文的时候，我才是我。`}</p>
    <p>{`新欢是欢，旧爱是爱。中间的，可什么都不算。`}</p>
    <p>{`文字并非如此。有些话，确实是不好说的那么明白，心照不宣反而最好。
你懂我的难言之隐，我懂你的言不由衷。`}</p>
    <p>{`若我的文字能给你带来些许心灵上的碰撞，自然是最好。`}</p>
    <p>{`那至少说明，我的文字功底没那么差。`}</p>
    <p>{`若是读完觉得毫无营养，8好意思，请再读几遍。`}</p>
    <p>{`我可是月心啊，怎能轻易认输呢？`}</p>
    <p>{`饭要一点点吃，砖要一块块搬。`}</p>
    <p>{`节奏会慢，但步子，绝不退。`}</p>
    <p>{`满甲营既已满甲，该当如何？`}</p>
    <p>{`“死战!”`}</p>
    <p>{`半分书生气，半分江湖气，这大概就是我的文风？`}</p>
    <p>{`也许是，也许不是。`}</p>
    <p>{`我不会给自己定什么风格，我的风格完全取决于心境。`}</p>
    <p>{`而心境这东西，还不是和人心一样，说变就变，又算的上几条酸菜鱼呢？`}</p>
    <p>{`我有一壶酒，足以慰风尘。`}</p>
    <p>{`倾尽江海里，赠予天下人。`}</p>
    <p>{`诸君不妨与我，举杯邀明月，共吃酸菜鱼。`}</p>
    <p>{`夜已深，万家灯火，当有一盏等你。`}</p>
    <p>{`若无，此文作灯，为你而留。`}</p>
    <p>{`情如风雪无常，却是一动即殇。`}</p>
    <p>{`感谢你这么好看还来阅读我的文章，`}</p>
    <p>{`我是冷月心，下期再见。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      